import React, { useState, useEffect } from "react";
import NavBar from "./_NavBar";
import { Cookie } from "../utils/functions";
import { useMeasure } from "../utils/hooks";

export default function Header({ ...data }) {
    const [bulbStatus, setBulbStatus] = useState("");
    const [ref, bounds] = useMeasure();

    const switchBulb = (...args) => {
        let delay = typeof args[0] == "number" ? args[0] : 1e3;
        let state = typeof args[0] == "string" ? args[0] : typeof args[1] == "string" ? args[1] : "init";

        const lightBulb = document.querySelector("svg.lightBulb");
        const isDarkMode = document.querySelector("html").classList.contains("themeDark");

        if (state === "init") {
            setBulbStatus(isDarkMode ? "Light Up" : "Dim Lights");
            isDarkMode ? lightBulb.classList.remove("active") : lightBulb.classList.add("active");
            return;
        }

        setBulbStatus(isDarkMode ? "Lighting..." : "Dimming...");

        setTimeout(function () {
            // toggle and save state
            document.querySelector("html").classList.toggle("themeDark");
            Cookie.set("darkMode", !isDarkMode ? "yes" : "no", 6);

            setBulbStatus(isDarkMode ? "Dim Lights" : "Light Up");
            isDarkMode ? lightBulb.classList.add("active") : lightBulb.classList.remove("active");
        }, delay);
        return;
    };

    useEffect(() => {
        // check for user taste and time
        const hour = new Date().getHours();
        const darkMode = Cookie.get("darkMode") ? Cookie.get("darkMode") === "yes" : hour <= 6 || 18 <= hour;

        darkMode ? switchBulb(0, "change") : switchBulb(0);
    }, []);

    return (
        <header>
            <div {...ref} className="container">
                <div className="d-flex align-items-center justify-content-between mt-4 mb-3 mainBox">
                    <a className="d-flex align-items-center text-decoration-none font-cursive cvLogo" href="/">
                        <svg className="adapt" viewBox="0 0 31 31" width="32" height="32">
                            <path d="M1.9,15.3c-0.1-0.5-0.6-0.9-1.1-0.9C0.3,14.5-0.1,15,0,15.6C0.3,18,4.9,27.4,7.6,30c0.2,0.2,0.4,0.3,0.7,0.3 S8.8,30.2,9,30c0.4-0.4,0.4-1,0-1.4C6.6,26.4,2.2,17.3,1.9,15.3z M21.8,5.4c-1.8-2.7-4.4-3.9-7.5-3.6C10,2.3,8,4.3,7.1,5.9 c-1.4,2.5-1.4,5.8,0.1,9.3l0.1,0.3c1.9,4.6,4.2,9.5,7.2,9.5c1.8,0,3.4-1.1,4.5-3.1c2.1-3.9,2-10.4-0.2-13.6 c-1.1-1.6-2.6-2.4-4.4-2.2c-1.8,0.2-3.3,1.1-4.1,2.5s-0.9,3.3-0.1,5.2c0.5,1.3,1.9,3.7,3.7,3.8c1.3,0,2.4-0.8,2.9-2.2 c0.6-1.8,0.1-4-1.3 -5.2c-0.6-0.5-1.7-0.5-2.4,0.1c-0.3,0.2-1.1,1-0.4,2.4c0.2,0.5,0.8,0.7,1.3,0.5s0.7-0.8,0.5-1.2 c0.6,0.7,0.8,1.9,0.5,2.8c-0.3,0.8-0.9,0.8-1,0.8c-0.4,0-1.4-1-1.9-2.5c-0.6-1.4-0.6-2.6-0.1-3.5c0.5-0.8,1.4-1.4,2.6-1.5 c1-0.1,1.9,0.3,2.5,1.3c1.8,2.6,1.8,8.4,0.1,11.6c-0.7,1.4-1.7,2.1-2.7,2.1c-1.3,0-3.2-2.8-5.5-8.3l-0.1-0.3 c-1.3-3-1.3-5.6-0.2-7.6c1-1.7,2.9-2.8,5.7-3.1c2.4-0.3,4.3,0.6,5.6,2.7c2.7,4.1,2.8,12.1,0.1,17.1c-1,1.8-2.6,3.9-5.3,3.9 c0,0,0,0-0.1,0c-2.1,0-4.4-2.4-6.8-7.1l-0.5-1.1c-1.9-3.6-3.8-7.2-3.3-11.2C4.5,6,5.7,3.7,7.6,1.9c0.4-0.4,0.4-1,0-1.4 s-1-0.4-1.4,0C4,2.6,2.5,5.3,2.2,7.9c-0.5,4.5,1.5,8.5,3.5,12.3l0.5,1.1c2.9,5.5,5.7,8.1,8.5,8.2h0.1c2.8,0,5.3-1.8,7-4.9 C25.1,18.9,25,10.1,21.8,5.4z M22.4,0.3c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4c3.6,3.4,5.1,8,4.9,14.2c-0.3,6.1-2.8,11-4.9,13.5 c-0.4,0.4-0.3,1,0.1,1.4c0.2,0.2,0.4,0.2,0.6,0.2c0.3,0,0.5-0.1,0.7-0.3c3.1-3.6,5.1-9.1,5.4-14.7C28.2,9.2,26.4,4.1,22.4,0.3z M0.6,5.7c0.1,0,0.2,0.1,0.3,0.1c0.4,0,0.8-0.2,0.9-0.6C2,4.7,2.2,4.4,2.4,4c0.2-0.5,0-1.1-0.4-1.3c-0.5-0.2-1.1,0-1.3,0.4 C0.4,3.5,0.2,3.9,0.1,4.4C-0.1,4.9,0.1,5.5,0.6,5.7z M28.4,7.2C28.5,7.7,28.9,8,29.3,8c0.1,0,0.2,0,0.3,0c0.5-0.1,0.8-0.7,0.7-1.2 c-0.7-2.5-1.5-4.4-2.7-6.1c-0.3-0.4-0.9-0.5-1.4-0.2c-0.4,0.3-0.5,0.9-0.2,1.4C27,3.3,27.8,5,28.4,7.2z M30.2,19.4 c-0.5-0.1-1,0.3-1.1,0.8c-0.5,2.9-1.9,6.1-3.3,9.2c-0.2,0.5,0,1.1,0.5,1.3c0.1,0.1,0.3,0.1,0.4,0.1c0.4,0,0.7-0.2,0.9-0.6 c1.4-3.2,2.9-6.6,3.4-9.7C31.1,20,30.7,19.5,30.2,19.4z M2.2,24.9c-0.2-0.5-0.8-0.7-1.3-0.5s-0.7,0.8-0.5,1.3 c0.7,1.5,1.4,2.8,2.2,4.1c0.2,0.3,0.5,0.5,0.8,0.5c0.2,0,0.3,0,0.5-0.1c0.5-0.3,0.6-0.9,0.4-1.4C3.6,27.6,2.8,26.3,2.2,24.9z M14.4,21.1c1.4-0.1,2.3-0.7,2.9-1.9c0.3-0.5,0.1-1.1-0.4-1.3c-0.5-0.3-1.1-0.1-1.3,0.4c-0.3,0.6-0.6,0.8-1.3,0.8 c-0.5,0-1,0.5-0.9,1C13.4,20.7,13.9,21.1,14.4,21.1L14.4,21.1z" />
                        </svg>
                        <span className="ml-2 fontCursive">.{data.about.highlights}</span>
                    </a>
                    <div className="text-right">
                        <button className="btn btn-default" onClick={(e) => e.preventDefault() || switchBulb("change")}>
                            <span>{bulbStatus}</span>
                            <svg className="lightBulb" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 714 714">
                                <g className="lightBulbLight">
                                    <defs>
                                        <clipPath id="lightBulbLightClip">
                                            <polygon points="514,329 436,369 436,436 299,436 293,360 489,280" />
                                        </clipPath>
                                    </defs>
                                    <g clipPath="url(#lightBulbLightClip)">
                                        <line x1="330" y1="369" x2="330" y2="435" />
                                        <polyline points="478,313 402,349 402,435" />
                                    </g>
                                    <line x1="478" y1="129" x2="254" y2="233" />
                                    <line x1="354" y1="125" x2="254" y2="173" />
                                    <line x1="478" y1="189" x2="254" y2="293" />
                                    <line x1="478" y1="249" x2="254" y2="353" />
                                </g>

                                <path className="lightBulbBase" d="M292.431,505c0.863,4.314,5.169,7.845,9.569,7.845h128c4.4,0,8.706-3.53,9.569-7.845l12.861-64.311c0.863-4.314-2.03-7.845-6.431-7.845H286c-4.4,0-7.294,3.53-6.431,7.845L292.431,505z" />
                                <g className="lightBulbScrews">
                                    <defs>
                                        <clipPath id="lightBulbScrewsClip">
                                            <polygon points="304.333,511 433.667,511 430,521.5 281.667,547.167 280.333,521.5" />
                                        </clipPath>
                                    </defs>
                                    <line clipPath="url(#lightBulbScrewsClip)" x1="430" y1="505" x2="302" y2="529" />
                                    <line className="st4" x1="430" y1="537" x2="302" y2="561" />
                                    <line className="st4" x1="430" y1="569" x2="302" y2="593" />
                                    <line className="st4" x1="410" y1="605" x2="322" y2="621" />
                                </g>
                            </svg>
                        </button>
                    </div>
                </div>
                <NavBar {...{ bounds, data }} />
            </div>
        </header>
    );
}
